import { render, staticRenderFns } from "./AssignTo.vue?vue&type=template&id=99071506&scoped=true"
import script from "./AssignTo.vue?vue&type=script&lang=js"
export * from "./AssignTo.vue?vue&type=script&lang=js"
import style0 from "./AssignTo.vue?vue&type=style&index=0&id=99071506&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99071506",
  null
  
)

export default component.exports